import axios from "axios";

export default axios.create({
    baseURL: window.location.hostname.endsWith('thenclab.com') || window.location.hostname.endsWith('localhost')? 
        "http://hubtalent.thenclab.com/itbank-rws" : 
        "https://hubtalent.es/itbank-rws"
});